var filterFalse = object => Object.assign(...Object.keys(object).filter(key => object[key] !== false).map(key => ({
  [key]: object[key]
})));
export default function sendEnquiry(url, data) {
  var request = filterFalse(data);
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(request)
  }).then(response => {
    if (!response.ok) {
      throw new Error("server returned ".concat(response.status, ": ").concat(response.statusText));
    }
    return response.json();
  });
}